import { defineStore } from 'pinia';
import GroupsEntity from '@/v2/modules/contacts/entities/groups';
import { Alert } from '@/v2/plugins/alert';
import { t } from '@/locales/index';

export const useContactStore = defineStore('ContactsContactsStore', {
	state: () => ({
		// loading: false,
		// loadingPage: false,
        // loadingDelete: false,
        // loadingList: false,
        isOpenContactDialog: false,
        isOpenUploadContactsDialog: false,
        // list: [],
        // contactList: [],
		form: {
			name: '',
            file: undefined,
            customer_ids: [],
		},
	}),
	actions: {
		// async create(id) {
        //     if(!id && !this.form?.file && this.form?.customer_ids?.length === 0){
        //         Alert.error(t('campaigns.createEdit.please-add-contacts'));
        //         return;
        //     }
        //
		// 	this.loading = true;
		// 	try {
		// 		if (id) await GroupsEntity.update(id, {name: this.form.name});
		// 		else await GroupsEntity.create(this.form);
		// 		Alert.success(t(id ? 'updatedSuccessfully' : 'createdSuccessfully'));
		// 		return true;
		// 	} catch (error) {
		// 		Alert.error(error?.response?.data?.message);
		// 	} finally {
		// 		this.loading = false;
		// 	}
		// },
        // async get(id) {
        //     this.loadingPage = true;
        //
        //     try {
        //         try {
        //             const resp = await GroupsEntity.get(id);
        //             const data = resp?.data?.result?.group;
        //
        //             this.form['name'] = data?.name;
        //         } catch (error) {
        //             console.error(error);
        //         } finally {
        //             this.loadingPage = false;
        //         }
        //     } catch (error) {
        //         console.error(error);
        //         this.loadingPage = false;
        //     }
        // },
        // async remove(id) {
        //     this.loadingDelete = true;
        //
        //     try {
        //         const resp = await GroupsEntity.remove(id);
        //         this.fetch();
        //     } catch (error) {
        //         console.error(error);
        //     } finally {
        //         this.loadingDelete = false;
        //     }
        // },
        // reset(){
        //     this.form = {
        //         name : ''
        //     }
        // }
	},
});
